var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#9FB8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 4C11.6307 4 12.75 5.11929 12.75 6.5V10C12.75 11.3807 11.6307 12.5 10.25 12.5C8.86929 12.5 7.75 11.3807 7.75 10V6.5C7.75 5.11929 8.86929 4 10.25 4ZM14.5 9.625C14.7071 9.625 14.875 9.79289 14.875 10C14.875 12.3015 13.0001 14.1802 10.6255 14.3608L10.625 16C10.625 16.2071 10.4571 16.375 10.25 16.375C10.0602 16.375 9.90325 16.2339 9.87842 16.0509L9.875 16L9.87504 14.3608C7.50017 14.1804 5.625 12.3016 5.625 10C5.625 9.79289 5.79289 9.625 6 9.625C6.20711 9.625 6.375 9.79289 6.375 10C6.375 11.9968 8.10498 13.625 10.25 13.625C12.395 13.625 14.125 11.9968 14.125 10C14.125 9.79289 14.2929 9.625 14.5 9.625ZM8.5 6.5C8.5 5.5335 9.2835 4.75 10.25 4.75C11.2165 4.75 12 5.5335 12 6.5V10C12 10.9665 11.2165 11.75 10.25 11.75C9.2835 11.75 8.5 10.9665 8.5 10V6.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.a791f7b6e585ee7e415d261c4c65ce35.svg";
export { ForwardRef as ReactComponent };